import angular from 'angular'

import { noop } from 'lodash-es'

import setCss from '../utils/set-css'
import StrictObj from '../utils/strict-obj'
import embedResize from '../utils/embed-resize'
import extractRawElm from '../utils/extract-raw-elm'
import viewportResize from '../utils/viewport-resize'

import { fmtTranslateY } from '../utils/fmt-translate'
import { getTransformY } from '../utils/get-transform'

angular
  .module('ggs.gallery-modal-list')
  .factory('GmlIframeSyncInternal', GmlIframeSyncInternalProvider)
  .factory('GmlPageSyncInternal', GmlPageSyncInternalProvider)
  .factory('GmlFakeSyncInternal', GmlFakeSyncInternalProvider)
  .factory('GmlSite', GmlSiteProvider)

function GmlIframeSyncInternalProvider(qh) {

  const DEBOUNCE_DELAY = 150 // ms

  return function GmlIframeSyncInternal($syncElm) {
    const handler = qh.debounce(update, DEBOUNCE_DELAY)

    embedResize.position.on(handler)
    if (embedResize.isPositionReady()) {
      update(
        embedResize.getFrameWidth(),
        embedResize.getFrameHeight(),
        embedResize.getViewportOffset(),
        embedResize.getViewportHeight())
    }

    return StrictObj({ destroy })

    function destroy() {
      embedResize.position.off(handler)
    }

    function update(_frameWidth, frameHeight, vportOffset, vportHeight) {
      updateHeight(vportHeight, frameHeight)
      updateOffset(vportOffset, vportHeight, frameHeight)
    }

    function updateHeight(vportHeight, frameHeight) {
      const syncHeight = calcSyncHeight(vportHeight, frameHeight)
      setCss($syncElm, 'height', syncHeight)
    }

    function updateOffset(vportOffset, vportHeight, frameHeight) {
      let syncOffset = null

      const syncHeight = calcSyncHeight(vportHeight, frameHeight)
      if (vportOffset >= syncHeight && vportOffset <= frameHeight) {
        syncOffset = frameHeight - vportOffset // gallery is in viewport
      } else if (vportOffset < syncHeight) {
        syncOffset = frameHeight - syncHeight // viewport below the gallery's bottom
      } else if (vportOffset > frameHeight) {
        syncOffset = 0 // viewport above the gallery's top
      }

      setCss($syncElm, 'transform', fmtTranslateY(syncOffset))
    }

    function calcSyncHeight(vportHeight, frameHeight) {
      return vportHeight > frameHeight
        ? frameHeight
        : vportHeight
    }
  }
}

function GmlPageSyncInternalProvider(qh, ElementPosition) {

  const DEBOUNCE_DELAY = 150 // ms

  return function GmlPageSyncInternal($syncElm) {
    const handler = qh.debounce(update, DEBOUNCE_DELAY)
    const topChangeDetector = ElementPosition.Top($syncElm, handler)
    return StrictObj({ destroy })

    function update() {
      const syncElm = extractRawElm($syncElm)
      const syncHeight = viewportResize.getHeight()
      const syncOffset = -1 * Math.round(syncElm.getBoundingClientRect().top) + getTransformY($syncElm)
      updateHeight(syncHeight)
      updateOffset(syncOffset)
    }

    function destroy() {
      topChangeDetector.destroy()
    }

    function updateHeight(syncHeight) {
      setCss($syncElm, 'height', syncHeight)
    }

    function updateOffset(syncOffset) {
      setCss($syncElm, 'transform', fmtTranslateY(syncOffset))
    }
  }
}

function GmlFakeSyncInternalProvider() {
  return function GmlFakeSyncInternal() {
    return StrictObj({ destroy: noop })
  }
}

function GmlSiteProvider(
  env,
  domh,
  GmlPageSyncInternal,
  GmlFakeSyncInternal,
  GmlIframeSyncInternal) {

  const QS_SYNC = '.ggs-gml__sync'

  return function GmlSite($listElm, properties) {
    const syncElm = domh.find($listElm, QS_SYNC)
    if (env.isIframeMode) {
      return GmlIframeSyncInternal(syncElm)
    } else if (properties.modals_fix_fixed_position) {
      return GmlPageSyncInternal(syncElm)
    } else {
      return GmlFakeSyncInternal(syncElm)
    }
  }
}
